import { render } from "./Breadcrumbs.vue?vue&type=template&id=4dbe46de&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=4dbe46de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbe46de"],['__file',"resources/js/components/shared/Breadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dbe46de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dbe46de', __exports__)) {
    api.reload('4dbe46de', __exports__)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=4dbe46de&scoped=true", () => {
    api.rerender('4dbe46de', render)
  })

}


export default __exports__